import React, { useEffect, useState } from 'react';
import './my-orgs.styles.scss';
import { useSelector } from 'react-redux';
import AgeCheck from '@/components/layout-auth/age-check/age-check.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEarthAmericas } from '@fortawesome/free-solid-svg-icons';
import { Route, Routes, useNavigate } from 'react-router-dom';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import org_placeholder from '@/assets/placeholder-icon-org.jpg';
import MyOrgView from './my-org-view.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import InfoLinks from '@/components/SHARED/info-links/info-links.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const MyOrgs = ({ orgs }) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ orgsToDisplay, setOrgsToDisplay ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const navigate = useNavigate('/quote');

    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 3000)
        changeDocumentTitle('Gamably | Your Organizations');
        return () => {
            if (timeout) clearTimeout(timeout);
        }
    }, [])

    useEffect(() => {
        console.log(orgs);
        if (!orgs) return;
        let sortedOrgs = Object.values(orgs)
        .sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
        setOrgsToDisplay([...sortedOrgs])
        setLoading(false);
    }, [orgs])
    
    return (
        <div className='my-orgs'>
            <AgeCheck />
            {/* <Layout> */}
            <Routes>
                <Route path=''
                    element={
                    <div className={`orgs-content ${screenSize}`}>
                        <div className={`g-card ${screenSize}`}>
                            <div className='section-title with-icon'>
                                <span>Your Organizations</span>
                                {
                                    (userProfile) &&
                                    <button 
                                        className={`g-button ${screenSize === 'mobile' ? 'small-btn' : ''}`} 
                                        onClick={() => navigate('/quote')}>
                                        Create{
                                            (screenSize === 'largeTablet' || screenSize === 'desktop') &&
                                            ' a New Organization'
                                        }
                                        <FontAwesomeIcon 
                                            icon={faEarthAmericas} 
                                            size="lg" 
                                            className='button-icon' />
                                    </button>
                                }
                            </div>

                            <hr  />
                            {
                                (loading) 
                                ?
                                <>
                                    <div></div>
                                    <div className='center'><ThreeDotsLoader /></div>
                                </>
                                :
                                (orgsToDisplay.length > 0)
                                ?
                                <div className='org-list'>
                                    {
                                        orgsToDisplay.map(o => (
                                            <button
                                                key={o.orgId} 
                                                className='org-list-item g-button'
                                                onClick={() => navigate(o.path)}>
                                                <div className='icon'>
                                                    <ImageContainer 
                                                        src={o.icon ?? org_placeholder}
                                                        className='org-icon' />
                                                </div>
                                                <div className='title'>
                                                    {o.name}
                                                </div>
                                            </button>
                                        ))
                                    }
                                </div>
                                :
                                <div className='center-col'>
                                    <h3>No Organizations Yet...</h3>
                                </div>
                            }
                        </div>
                        {
                            (screenSize === 'desktop') &&
                            <div className="g-space-2"></div>
                        }
                    </div>
                    }></Route>
                <Route path=':orgPath'
                    element={
                        <div className='orgs-content'>
                            <MyOrgView orgs={orgs} />
                            {
                                (screenSize === 'desktop') &&
                                <div className="g-space-2"></div>
                            }
                        </div>
                    }></Route>
            </Routes>
        </div>
    )
}

export default MyOrgs